export const sorted = <T extends { sortOrder: number }>(arr: Array<T>): Array<T> =>
  arr.sort((a, b) => a.sortOrder - b.sortOrder);
